import type React from 'react';

import { useMediaHitsContext } from '../../shared/context';

import { MediaHit } from './components/MediaHit';

export const MediaHitList: React.FC<{ ref?: React.RefObject<HTMLDivElement | null> }> = ({ ref }) => {
	const {
		data: { mediaEmbeds },
		actions: { removeMedia },
	} = useMediaHitsContext();

	// Don't render if there are no media hits to show
	if (mediaEmbeds.length === 0) {
		return null;
	}

	return (
		<div
			ref={ref}
			data-testid="media-hit-list"
			tabIndex={0}
			className="mt-5 box-border flex w-full max-w-full snap-x snap-mandatory flex-row flex-nowrap gap-4 overflow-x-auto scroll-smooth px-6 pb-10 md:snap-none md:scroll-auto md:px-8"
		>
			{mediaEmbeds.map((media) => (
				<MediaHit key={media.id} media={media} removeMedia={removeMedia} />
			))}
		</div>
	);
};
